import { render } from "./SwdLeadActions.vue?vue&type=template&id=24fb7b17"
import script from "./SwdLeadActions.vue?vue&type=script&lang=js"
export * from "./SwdLeadActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__